import Vue from 'vue';
import Vuex from 'vuex';
import phoneNumbers from '../helpers/phone-numbers.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        cartExpiryDate: new Date(),
        numbersCart: [],
        ppsNumber: "",
        receipt: "",
        submitted: false,
        numberType: "regional"
    },
    mutations: {
        addToCart(state, number) {
            state.numbersCart.push({
                number: number,
                route: '',
                valid: false
            });
            state.cartExpiryDate = new Date();
            state.submitted = false;
        },
        removeFromCart(state, number) {
            state.numbersCart = state.numbersCart.filter(function(item) {
                return item.number !== number;
            });
            
            state.cartExpiryDate = new Date();
            state.submitted = false;
        },
        refreshCart(state, numbers) {
            state.numbersCart = [];
            numbers.forEach(item => {
                state.numbersCart.push({
                    number: item.number,
                    route: item.target,
                    valid: item.target !== null ? phoneNumbers.validPhoneNumber(item.target) : false
                });
            });
        },
        updateCartValidation(state, { number, valid }){
            const cartItem = state.numbersCart.find(item => item.number === number);
            cartItem.valid = valid;
        },
        setReceipt(state, receipt){
            state.receipt = receipt;
        },
        updatePpsNumber(state, number) {
            state.ppsNumber = number;
        },
        refreshCartExpiry(state) {
            state.cartExpiryDate = new Date();
        },
        setNumberRoute(state, { route, number }) {
            const cartItem = state.numbersCart.find(item => item.number === number);
            cartItem.route = route;

            const sanitisedRoute = phoneNumbers.sanitisePhoneNumber(route);

            cartItem.valid = phoneNumbers.validPhoneNumber(sanitisedRoute);
        },
        setSubmitted(state) {
            state.submitted = true;
        },
        setNumberType(state, numberType){
            state.numberType = numberType;
        }
    },
    getters: {
        cartExpiryDate: state => state.cartExpiryDate,
        numbersCart: state => state.numbersCart,
        receipt: state => state.receipt,
        ppsNumber: state => state.ppsNumber,
        submitted: state => state.submitted,
        numberType: state => state.numberType
    }
});